// 开发
export const StripeListDev = [
  {
    price: 5000,
    link: "https://buy.stripe.com/test_bJe5kFcsO48k2uObm3dZ60a",
  },
  {
    price: 1000,
    link: "https://buy.stripe.com/test_fZu9AVfF08oAfhA9dVdZ609",
  },
  {
    price: 500,
    link: "https://buy.stripe.com/test_dRmfZjeAWbAMc5o61JdZ604",
  },
  {
    price: 100,
    link: "https://buy.stripe.com/test_00wcN778u9sEc5oeyfdZ603",
  },

  {
    price: 50,
    link: "https://buy.stripe.com/test_28EeVf2Se34g7P8ahZdZ608",
  },
];

// 线上
export const StripeList = [
  {
    price: 5000,
    link: "https://buy.stripe.com/aFa5kwbTteTp8yn5UlaAw0e",
  },
  {
    price: 1000,
    link: "https://buy.stripe.com/aEUbJN6Dv0MJfTycMQ",
  },
  {
    price: 500,
    link: "https://buy.stripe.com/fZu14ge1B6mT3e3ciJaAw0a",
  },
  {
    price: 100,
    link: "https://buy.stripe.com/eVa1590f78fb9va002",
  },
  {
    price: 50,
    link: "https://buy.stripe.com/bJe14gaPpbHd7ujdmNaAw0d",
  },
];
